import { RouterProvider } from "react-router-dom";
import router from "./services/routes";
import Header from "./components/Header/header";
import Footer from "./components/Footer/footer";
import { useAppSelector } from "./Redux/hook";
import Chat from "./components/Chat/chat";

function App() {
  const lightMode = useAppSelector((state) => state.mode.lightMode);
  return (
    <div className={!lightMode ? "darkMode" : "lightMode"} style={{ position: "relative" }}>
      <Header />
      <RouterProvider router={router} />
      <Footer />
      <Chat />
    </div>
  );
}

export default App;
